/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusUpRightIcon16Light = forwardRef('ArrowDRadiusUpRightIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.854 2.646a.5.5 0 0 0-.708.708L13.793 7H7.5A6.5 6.5 0 0 0 1 13.5a.5.5 0 0 0 1 0A5.5 5.5 0 0 1 7.5 8h6.293l-3.647 3.646a.5.5 0 0 0 .708.708l3.651-3.652a1.7 1.7 0 0 0 0-2.404l-3.651-3.652Z" })));
});
